import type { EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { FocusModeToggleMethod } from 'hooks/useFocusMode';

export const DICTAPHONE_CONTROLS_PLUGIN_ID = 'dictaphoneControls' as const;
export type DictaphoneControlsPluginID = typeof DICTAPHONE_CONTROLS_PLUGIN_ID;

export type DictaphoneControlsPluginOptions = Readonly<
  EditorPluginOptions & {
    ignoreMergeFieldsInNavigation?: boolean;
    toggleFocusMode?: (args: { method: FocusModeToggleMethod; enabled?: boolean }) => void;
  }
>;

export type DictaphoneControlsPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    DictaphoneControlsPluginOptions & {
      pluginID: DictaphoneControlsPluginID;
      pluginName: string;
    }
>;
